<template>
  <button
    type="button"
    @click="onClick"
    :disabled="disabled"
    class="wizard-item flex items-center btn btn-outlined border font-medium"
    :class="{
      'opacity-10': disabled,
      'border-black-light': !active,
      'wizard-item--active btn-secondary': active,
      'justify-center': textCenter,
      'text-center': textCenter
    }"
  >
    <img
      v-if="icon"
      :src="icon"
      alt="icon"
      width="48"
      height="48"
      class="mr-2"
    /><span class="wizard-item__text text-black-100 font-normal">{{
      title
    }}</span>
    <!-- <small v-if="score"><i>score: <strong>{{ score }}</strong></i></small> -->
  </button>
</template>

<script>
export default {
  name: "WizardItem",

  props: {
    disabled: { type: Boolean, default: false },
    title: { type: String, default: "Title" },
    score: { type: Number, required: false },
    active: { type: Boolean, default: false },
    icon: { type: String, required: false },
    onClick: { type: Function, default: () => {} },
    textCenter: { type: Boolean, default: true }
  }
};
</script>

<style lang="scss" scoped>
.wizard-item {
  height: 64px;
  &__text {
    color: #222 !important;
  }

  &:hover {
    background-color: #ecf7f8;
  }

  &--active {
    background-color: #ecf7f8;
  }
}
</style>
